import {Component, ElementRef, ViewChild, Input, OnInit, AfterViewInit} from '@angular/core';
import {TitleRequests} from '../catalog-api/model/title-requests';
import {UUID} from 'angular2-uuid';
import {ToasterService} from 'angular2-toaster';
import {TitleRequestsService} from '../title-requests/title-requests.service';
import {UserDetailsService} from '../../shared/user.details.service';
import {GeneralConstants} from '../../shared/general.constants';
import {get} from 'lodash';
import {CatalogService} from '../catalog-api/catalog.service';
import CommonUtils from '../../shared/common.util';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'title-requests-modal',
    templateUrl: 'title-requests-modal.component.html',
    styleUrls: ['title-requests-modal.component.scss']
})
export class TitleRequestsModalComponent implements OnInit, AfterViewInit {
    @ViewChild('modal', {read: ElementRef}) modal: ElementRef;

    collapsed = false;
    username;
    isAdmin;
    totalRequests;
    requestsIndex = 0;
    selectedRequest: TitleRequests = new TitleRequests();
    submittingRequest = false;
    private contentType: number = 0;
    private contentTypeValue: string = 'show';


    private _titleRequests;
    private loadMetadataIndicator = true;

    @Input()
    set titleRequests(titleRequests: TitleRequests[]) {
        if (titleRequests && titleRequests.length > 0) {
            // If there are requests, create a batch id, display the first title
            // and open the modal
            this._titleRequests = titleRequests;
            this.totalRequests = titleRequests.length;
            this.requestsIndex = 0;
            this.selectedRequest = titleRequests[0];
            this.selectedRequest.batchUUID = UUID.UUID();
            this.openModal();
        }
    }

    @Input()
    set createTitleRequests(create: boolean) {
        if (create) {
            this._titleRequests = [new TitleRequests()];
            this.totalRequests = 1;
            this.requestsIndex = 0;
            this.selectedRequest = this._titleRequests[0];
            this.selectedRequest.batchUUID = UUID.UUID();
            this.openModal();
        }
    }

    constructor(private toasterService: ToasterService,
                private titleRequestsService: TitleRequestsService, private catalogService: CatalogService,
                private userDetails: UserDetailsService,
                private generalConstants: GeneralConstants) {
    }

    ngOnInit() {
        this.isAdmin = this.userDetails.isAdmin();
    }

    ngAfterViewInit() {
    }

    onContentTypeChange(value: number) {
        this.contentType = value;

        if (value === 0) {
            this.contentTypeValue = 'show';
        }
        if (value === 1) {
            this.contentTypeValue = 'movie';
        }
        if (value === 2) {
            this.contentTypeValue = 'talent';
        }
        if (value === 3) {
            this.contentTypeValue = 'sports';
        }

    }

    async fetchDatasouceMapping() {

        // if (this.selectedRequest.parrotId) {
        //     const mappings = await this.titleRequestsService.getDatasourceMapping(this.selectedRequest.parrotId);
        //     if (mappings && mappings.length > 0) {
        //         this.selectedRequest.imdbId = mappings[0]['imdb'];
        //         this.selectedRequest.wikibaseId = mappings[0]['wikidata'];
        //         this.selectedRequest.tmdbId = mappings[0]['tmdb'];
        //     }
        // }

        let urlToGetParrotID;
        if (this.contentType === 0) {
            urlToGetParrotID = 'series_metadata';
        }
        if (this.contentType === 1) {
            urlToGetParrotID = 'movie_metadata';
        }
        if (this.contentType === 2) {
            urlToGetParrotID = 'talent_metadata';
        }

        let res;
        let parrotIDRes;
        let parrotID;
        try {
            if (this.selectedRequest.imdbId || this.selectedRequest.wikibaseId || this.selectedRequest.wikipageId || this.selectedRequest.tmdbId) {
                // we try to fetch metadata to auto fill year, network , original country
                // tslint:disable-next-line:max-line-length
                this.loadMetadataIndicator = false;
                res = await this.titleRequestsService.fetchMetadataFromEnrich(this.selectedRequest.imdbId, this.selectedRequest.wikibaseId, this.selectedRequest.wikipageId, this.selectedRequest.tmdbId, this.selectedRequest.justwatchId, null, null, this.contentTypeValue, null);
                const parrotIDQuery = await this.titleRequestsService.fetchParrotIDFromMeatdata(this.selectedRequest.imdbId, this.selectedRequest.wikibaseId, this.selectedRequest.wikipageId, this.selectedRequest.tmdbId, urlToGetParrotID);

                parrotIDRes = this.catalogService.callEsProxyLoadMetaData(parrotIDQuery, urlToGetParrotID);
                this.catalogService.callEsProxyLoadMetaData(parrotIDQuery, urlToGetParrotID)
                    .then((results) => {
                        parrotID = results.hits.hits[0] ? results.hits.hits[0]._source.parrot_id : this.selectedRequest.parrotId;
                        const title = results.hits.hits[0] ? results.hits.hits[0]._source.title : this.selectedRequest.title;
                        this.selectedRequest.parrotId = parrotID;
                        this.selectedRequest.title = title;
                        this.loadMetadataIndicator = true;

                    })
                    .catch((err) => {
                        this.loadMetadataIndicator = true;
                        console.error('Failed to load from metadata: ' + err.toString());
                    });

                if (res) {
                    // tslint:disable-next-line:comment-format
                    //dont overwrite value if already filled
                    this.selectedRequest.imdbId = this.selectedRequest.imdbId || get(res, 'metadata.data.external_mappings.imdb_id');
                    this.selectedRequest.wikibaseId = this.selectedRequest.wikibaseId || get(res, 'metadata.data.external_mappings.wikibase_id');
                    this.selectedRequest.wikipageId = this.selectedRequest.wikipageId || get(res, 'metadata.data.external_mappings.wiki_id');
                    this.selectedRequest.tmdbId = this.selectedRequest.tmdbId || get(res, 'metadata.data.external_mappings.tmdb_id');
                    this.selectedRequest.year = this.selectedRequest.year || get(res, 'metadata.data.release_year');

                    try {
                        if (this.contentType !== 1) {
                            this.selectedRequest.network = this.selectedRequest.network || get(res, 'metadata.data.original_network.0');
                            this.selectedRequest.country = this.selectedRequest.country || get(res, 'metadata.data.original_country.0');
                        } else {
                            this.selectedRequest.country = this.selectedRequest.country || this.getOrderedItems(get(res, 'metadata.data.original_country', []));
                        }
                    } catch (ex) {
                        console.log(ex);
                    }


                    this.selectedRequest.parrotId = this.selectedRequest.parrotId || get(res, 'metadata.parrot_id');
                    this.loadMetadataIndicator = true;

                } else {
                    this.loadMetadataIndicator = true;

                    this.toasterService.pop('info', 'metadata can not be found.You have to manually enter remaining fields');
                }
            } else {
                this.toasterService.pop('info', 'Could not find mappings between parrot id to others datasources.'
                    + 'Manually enter fields IMDB ID, Wikibase ID, Wikipage ID then retry.');
                this.loadMetadataIndicator = true;
            }
        } catch (ex) {
            console.log(ex);
            this.loadMetadataIndicator = false;
        }
    }

    private getOrderedItems(values) {
        const result = [];
        for (const item of values) {
            result.push(item.value);
        }
        console.log(result);
        return result[0];

    }

    handleNextRequest() {
        this.requestsIndex = this.requestsIndex + 1;
        this.selectedRequest = this._titleRequests[this.requestsIndex];
    }

    handlePreviousRequest() {
        this.requestsIndex = this.requestsIndex - 1;
        this.selectedRequest = this._titleRequests[this.requestsIndex];
    }

    openModal() {
        this.modal.nativeElement.style.display = 'block';
    }

    closeModal() {
        this.modal.nativeElement.style.display = 'none';
    }

    setDefaultContentSubType() {
        if (!this.selectedRequest.contentSubType) {
            this.selectedRequest.contentSubType = 'Sports';
        }
    }
    handleSubmit() {
        this.submittingRequest = true;
        if (this.doValidation()) {
            // Succeeded validation
            this.selectedRequest.contentType = this.contentTypeValue;
            // tslint:disable-next-line:comment-format
            //console.log(this.selectedRequest)
            this.titleRequestsService.createTitleRequest(this.userDetails.getUsername(), this.selectedRequest)
                .then((res) => {
                    this.toasterService.pop('success', `Successfully created title request for ${this.selectedRequest.title}`);
                    this.selectedRequest.submitted = true;
                    this.submittingRequest = false;
                    if (this.requestsIndex + 1 < this.totalRequests) {
                        this.handleNextRequest();
                    } else if (this._titleRequests.every(item => item.submitted)) {
                        this.closeModal();
                    }
                })
                .catch((err) => {
                    let errorJson = null;
                    if (err._body) {
                        errorJson = JSON.parse(err._body);
                    }
                    if (errorJson && errorJson.error && errorJson.error.message && errorJson.error.message === this.generalConstants.getTitleRequestAlreadyExistsMessage()) {
                        if (errorJson.error) {
                            this.toasterService.pop('error', errorJson.error.message);
                        } else {
                            this.toasterService.pop('error', errorJson.message);
                        }
                    } else {
                        console.error('Failed to create title request: ' + err.toString());
                        if (errorJson.error) {
                            this.toasterService.pop('error', errorJson.error.message);
                        } else {
                            this.toasterService.pop('error', errorJson.message);
                        }
                    }
                    this.submittingRequest = false;
                });
        } else {
            this.submittingRequest = false;
        }
    }

    handleCollapse() {
        this.collapsed = !this.collapsed;
    }

    doValidation() {
        if (!this.selectedRequest.title) {
            this.toasterService.pop('info', 'Request must have a title!');
            return false;
        }
        if (!(this.selectedRequest.parrotId || this.selectedRequest.link || (this.selectedRequest.country && this.selectedRequest.network))) {
            this.toasterService.pop('info', 'Must have either parrot id, link, or both country and network!');
            return false;
        }
        return true;
    }
}



// WEBPACK FOOTER //
// ./src/app/catalogue/title-requests-modal/title-requests-modal.component.ts